import { useAppSearchParams } from 'shared/libs/hooks/useAppSearchParams'
import { OrdersStatusKey } from 'shared/types/Common'

import { useEffect, useRef, useState } from 'react'

import OrderColumn from 'modules/Orders/components/OrderColumn'
import { SortedOrdersStatuses } from 'modules/Orders/model/statuses'
import EmptyOrdersTable from 'modules/Orders/ui/EmptyOrdersTable'

import TableSlider from 'shared/ui/TableSlider'

import { useAppSelector } from 'shared/config/redux/hooks/useRedux'

const OrderTable = () => {
  const tableRef = useRef<HTMLDivElement>(null)
  const { orders } = useAppSelector((state) => state.orders) || {}
  const { getParam } = useAppSearchParams()
  const [isEmptyTable, setIsEmptyTable] = useState<boolean>(false)

  useEffect(() => {
    if (!orders && !isEmptyTable) setIsEmptyTable(false)
    for (const orderStatus in orders) {
      const currentOrder = orders[orderStatus as OrdersStatusKey]
      if (
        (currentOrder.count === null && !getParam('status')) ||
        (currentOrder.count && currentOrder.count > 0) ||
        (currentOrder.isFetching && !isEmptyTable)
      ) {
        setIsEmptyTable(false)
        return
      }
    }
    setIsEmptyTable(true)
  }, [orders])

  return (
    <TableSlider
      childrenRef={tableRef}
      className="flex-1 flex flex-col"
    >
      <div
        className="flex-1 flex flex-col px-[24px] bg-snow_gray"
        ref={tableRef}
      >
        <div
          className={`${!isEmptyTable && 'flex-1'} flex gap-[8px] py-[12px]`}
        >
          {Object.keys(SortedOrdersStatuses).map((status) => (
            <OrderColumn
              key={status}
              status={status as OrdersStatusKey}
              columnStatus={SortedOrdersStatuses[status as OrdersStatusKey]}
            />
          ))}
        </div>
        {isEmptyTable && (
          <div className="flex-1 flex justify-center mt-6">
            <EmptyOrdersTable />
          </div>
        )}
      </div>
    </TableSlider>
  )
}

export default OrderTable
